import { ControlsToggleExtraContent, LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

export const components: LayoutComponent[] = [
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/05/29/principle/50cm-0ms.svg`,
        },
      },
      styles: {
        padding: "3%",
      },
    },
  },
];

export const extraContent: ControlsToggleExtraContent = [
  {
    type: "audioButton",
    options: {
      url: `${config.ASSETS_URL}/05/29/principle/sil50cm-0mps.wav`,
      icon: "cis-volume-high",
      shape: "round",
      size: "large",
      theme: "secondary",
      styles: {
        paddingTop: "1.5em",
      },
    },
  },
];
